import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { DsModalService } from '@amfam/ui-kit';

@Component({
  selector: 'ds-exit-flow-modal',
  templateUrl: './exit-flow-modal.component.html',
  styleUrls: ['./exit-flow-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ExitFlowModalComponent {
  @Input() exitFlowModalId: string;
  @Input() isPartner: boolean;
  @Output() cancelModal = new EventEmitter();
  @Output() exit = new EventEmitter();
  @Output() notifyAgent = new EventEmitter();

  public modalWidth = '596';

  constructor(private modalService: DsModalService) {}

  @Input() openModal = (isOpen: boolean) => () => {
    if (isOpen) {
      this.open();
    }
  };

  open(): void {
    this.modalService.open(this.exitFlowModalId);
  }

  close(): void {
    this.modalService.close(this.exitFlowModalId);
  }
}
